export const businessSlideTemplates = [
  {
    id: 'real-estate-listing',
    name: 'Real Estate Listing',
    category: 'Real Estate',
    businessCategory: 'Real Estate Agent',
    description: 'Property showcase presentation',
    theme: 'modern',
    thumbnail: 'https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=400&q=80',
    slides: [
      {
        title: 'PROPERTY SHOWCASE',
        content: '[Property Address]\n[Price] | [Beds] Bed | [Baths] Bath | [SqFt] SqFt',
        layout: 'title_content',
        backgroundImage: 'https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=1920&q=80',
        backgroundColor: '#1e40af'
      },
      {
        title: 'Key Features',
        content: '• Updated Kitchen & Bathrooms\n• Hardwood Floors Throughout\n• Private Backyard & Patio\n• 2-Car Garage\n• Walking Distance to Schools',
        layout: 'title_content',
        backgroundImage: '',
        backgroundColor: '#ffffff'
      },
      {
        title: 'Neighborhood Highlights',
        content: '• Top-Rated Schools\n• Parks & Recreation\n• Shopping & Dining\n• Easy Highway Access\n• Low Crime Rate',
        layout: 'title_content',
        backgroundImage: '',
        backgroundColor: '#eff6ff'
      },
      {
        title: 'Schedule Your Showing',
        content: '[Your Name]\n[Your Company]\n📱 [Phone]\n📧 [Email]\n🌐 [Website]',
        layout: 'title_content',
        backgroundImage: '',
        backgroundColor: '#1e40af'
      }
    ]
  },
  {
    id: 'restaurant-menu',
    name: 'Restaurant Menu',
    category: 'Food & Hospitality',
    businessCategory: 'Restaurant Owner',
    description: 'Showcase your menu and specialties',
    theme: 'modern',
    thumbnail: 'https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?w=400&q=80',
    slides: [
      {
        title: '[Restaurant Name]',
        content: 'Authentic Flavors, Unforgettable Experience',
        layout: 'title_content',
        backgroundImage: 'https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?w=1920&q=80',
        backgroundColor: '#0f172a'
      },
      {
        title: 'Featured Dishes',
        content: '[Dish 1] - $[Price]\n[Description]\n\n[Dish 2] - $[Price]\n[Description]\n\n[Dish 3] - $[Price]\n[Description]',
        layout: 'title_content',
        backgroundImage: 'https://images.unsplash.com/photo-1504674900247-0877df9cc836?w=1920&q=80',
        backgroundColor: '#ffffff'
      },
      {
        title: 'Special Offers',
        content: '🎉 Happy Hour: 3-6 PM Daily\n👨‍👩‍👧‍👦 Family Meals: [Days]\n🎂 Birthday Special: Free Dessert\n📱 Order Online: 10% Off',
        layout: 'title_content',
        backgroundImage: '',
        backgroundColor: '#f8fafc'
      },
      {
        title: 'Visit Us Today',
        content: '📍 [Address]\n📞 [Phone]\n🕐 Hours: [Hours]\n🌐 [Website]\n📱 [Social Media]',
        layout: 'title_content',
        backgroundImage: '',
        backgroundColor: '#0f172a'
      }
    ]
  },
  {
    id: 'salon-services',
    name: 'Salon & Spa Services',
    category: 'Beauty',
    businessCategory: 'Hair Stylist',
    description: 'Beauty and wellness services showcase',
    theme: 'modern',
    thumbnail: 'https://images.unsplash.com/photo-1560066984-138dadb4c035?w=400&q=80',
    slides: [
      {
        title: '[Salon Name]',
        content: 'Where Beauty Meets Confidence',
        layout: 'title_content',
        backgroundImage: 'https://images.unsplash.com/photo-1560066984-138dadb4c035?w=1920&q=80',
        backgroundColor: '#ec4899'
      },
      {
        title: 'Our Services',
        content: '💇 Hair Styling & Cuts\n💅 Manicure & Pedicure\n💆 Spa Treatments\n💄 Makeup & Lashes\n✨ Special Occasion Packages',
        layout: 'title_content',
        backgroundImage: '',
        backgroundColor: '#fdf2f8'
      },
      {
        title: 'Pricing Packages',
        content: '✨ Express Package: $[Price]\n• Quick cut & style\n\n💎 Signature Package: $[Price]\n• Full service treatment\n\n👑 VIP Package: $[Price]\n• Complete pampering experience',
        layout: 'title_content',
        backgroundImage: '',
        backgroundColor: '#ffffff'
      },
      {
        title: 'Book Your Appointment',
        content: '📱 Call/Text: [Phone]\n💻 Online: [Website]\n📍 Location: [Address]\n⏰ Hours: [Hours]',
        layout: 'title_content',
        backgroundImage: '',
        backgroundColor: '#ec4899'
      }
    ]
  },
  {
    id: 'fitness-training',
    name: 'Fitness Training',
    category: 'Health & Wellness',
    businessCategory: 'Personal Trainer',
    description: 'Fitness programs and training packages',
    theme: 'modern',
    thumbnail: 'https://images.unsplash.com/photo-1534438327276-14e5300c3a48?w=400&q=80',
    slides: [
      {
        title: 'TRANSFORM YOUR BODY',
        content: 'Expert Personal Training',
        layout: 'title_content',
        backgroundImage: 'https://images.unsplash.com/photo-1534438327276-14e5300c3a48?w=1920&q=80',
        backgroundColor: '#ef4444'
      },
      {
        title: 'Training Programs',
        content: '🏋️ Weight Training\n🏃 Cardio & Conditioning\n🧘 Flexibility & Mobility\n🥗 Nutrition Coaching\n📊 Progress Tracking',
        layout: 'title_content',
        backgroundImage: '',
        backgroundColor: '#fef2f2'
      },
      {
        title: 'Success Stories',
        content: '"Lost 30 lbs in 3 months!"\n- Client Name\n\n"Finally achieved my fitness goals"\n- Client Name\n\n"Best investment in my health"\n- Client Name',
        layout: 'title_content',
        backgroundImage: 'https://images.unsplash.com/photo-1571019614242-c5c5dee9f50b?w=1920&q=80',
        backgroundColor: '#ffffff'
      },
      {
        title: 'Start Your Journey',
        content: '💪 Free Consultation\n📱 [Phone]\n📧 [Email]\n📍 [Gym/Location]\n🌐 [Website]',
        layout: 'title_content',
        backgroundImage: '',
        backgroundColor: '#ef4444'
      }
    ]
  },
  {
    id: 'law-firm',
    name: 'Law Firm Services',
    category: 'Professional Services',
    businessCategory: 'Lawyer',
    description: 'Legal services presentation',
    theme: 'modern',
    thumbnail: 'https://images.unsplash.com/photo-1589829545856-d10d557cf95f?w=400&q=80',
    slides: [
      {
        title: '[Law Firm Name]',
        content: 'Trusted Legal Representation',
        layout: 'title_content',
        backgroundImage: 'https://images.unsplash.com/photo-1589829545856-d10d557cf95f?w=1920&q=80',
        backgroundColor: '#1e3a8a'
      },
      {
        title: 'Practice Areas',
        content: '⚖️ Family Law\n🏢 Business Law\n🏠 Real Estate Law\n🚗 Personal Injury\n📝 Estate Planning',
        layout: 'title_content',
        backgroundImage: '',
        backgroundColor: '#eff6ff'
      },
      {
        title: 'Why Choose Us',
        content: '• 20+ Years Experience\n• Proven Track Record\n• Personalized Service\n• Free Initial Consultation\n• Flexible Payment Options',
        layout: 'title_content',
        backgroundImage: '',
        backgroundColor: '#ffffff'
      },
      {
        title: 'Schedule Consultation',
        content: '📞 [Phone]\n📧 [Email]\n📍 [Office Address]\n🌐 [Website]\n\nConfidential & Professional',
        layout: 'title_content',
        backgroundImage: '',
        backgroundColor: '#1e3a8a'
      }
    ]
  },
  {
    id: 'contractor-services',
    name: 'Contractor Services',
    category: 'Home Services',
    businessCategory: 'Contractor',
    description: 'Construction and renovation services',
    theme: 'modern',
    thumbnail: 'https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=400&q=80',
    slides: [
      {
        title: '[Company Name]',
        content: 'Quality Construction & Remodeling',
        layout: 'title_content',
        backgroundImage: 'https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=1920&q=80',
        backgroundColor: '#f59e0b'
      },
      {
        title: 'Our Services',
        content: '🏗️ New Construction\n🔨 Home Remodeling\n🏠 Kitchen & Bath Renovations\n🪟 Additions & Extensions\n🎨 Commercial Projects',
        layout: 'title_content',
        backgroundImage: '',
        backgroundColor: '#fffbeb'
      },
      {
        title: 'Why Choose Us',
        content: '✓ Licensed & Insured\n✓ Quality Craftsmanship\n✓ On-Time Completion\n✓ Fair Pricing\n✓ 5-Year Warranty',
        layout: 'title_content',
        backgroundImage: 'https://images.unsplash.com/photo-1541888946425-d81bb19240f5?w=1920&q=80',
        backgroundColor: '#ffffff'
      },
      {
        title: 'Free Estimate',
        content: '📞 Call: [Phone]\n📧 Email: [Email]\n📍 Serving: [Service Area]\n🌐 Portfolio: [Website]',
        layout: 'title_content',
        backgroundImage: '',
        backgroundColor: '#f59e0b'
      }
    ]
  },
  {
    id: 'photography-portfolio',
    name: 'Photography Portfolio',
    category: 'Creative Services',
    businessCategory: 'Photographer',
    description: 'Showcase your photography work',
    theme: 'modern',
    thumbnail: 'https://images.unsplash.com/photo-1452587925148-ce544e77e70d?w=400&q=80',
    slides: [
      {
        title: '[Your Name] Photography',
        content: 'Capturing Life\'s Beautiful Moments',
        layout: 'title_content',
        backgroundImage: 'https://images.unsplash.com/photo-1452587925148-ce544e77e70d?w=1920&q=80',
        backgroundColor: '#0f172a'
      },
      {
        title: 'Services Offered',
        content: '📸 Wedding Photography\n👶 Family Portraits\n🎓 Senior Photos\n🏢 Corporate Events\n🎨 Creative Sessions',
        layout: 'title_content',
        backgroundImage: '',
        backgroundColor: '#f8fafc'
      },
      {
        title: 'Packages',
        content: '📦 Basic Package: $[Price]\n• 2 hours coverage\n• 50+ edited photos\n\n💎 Premium Package: $[Price]\n• Full day coverage\n• 200+ edited photos\n• Online gallery',
        layout: 'title_content',
        backgroundImage: '',
        backgroundColor: '#ffffff'
      },
      {
        title: 'Book Your Session',
        content: '📱 [Phone]\n📧 [Email]\n📷 Instagram: [@handle]\n🌐 Portfolio: [Website]',
        layout: 'title_content',
        backgroundImage: '',
        backgroundColor: '#0f172a'
      }
    ]
  },
  {
    id: 'dental-practice',
    name: 'Dental Practice',
    category: 'Healthcare',
    businessCategory: 'Dentist',
    description: 'Dental services and patient care',
    theme: 'modern',
    thumbnail: 'https://images.unsplash.com/photo-1588776814546-1ffcf47267a5?w=400&q=80',
    slides: [
      {
        title: '[Practice Name]',
        content: 'Creating Healthy, Beautiful Smiles',
        layout: 'title_content',
        backgroundImage: 'https://images.unsplash.com/photo-1588776814546-1ffcf47267a5?w=1920&q=80',
        backgroundColor: '#06b6d4'
      },
      {
        title: 'Our Services',
        content: '🦷 General Dentistry\n✨ Cosmetic Dentistry\n🔧 Orthodontics\n🚨 Emergency Care\n👶 Pediatric Dentistry',
        layout: 'title_content',
        backgroundImage: '',
        backgroundColor: '#ecfeff'
      },
      {
        title: 'Why Choose Us',
        content: '• State-of-the-Art Technology\n• Gentle, Caring Staff\n• Flexible Scheduling\n• Insurance Accepted\n• Payment Plans Available',
        layout: 'title_content',
        backgroundImage: '',
        backgroundColor: '#ffffff'
      },
      {
        title: 'Schedule Appointment',
        content: '📞 [Phone]\n📧 [Email]\n📍 [Address]\n⏰ Hours: [Hours]\n🌐 [Website]',
        layout: 'title_content',
        backgroundImage: '',
        backgroundColor: '#06b6d4'
      }
    ]
  },
  {
    id: 'insurance-services',
    name: 'Insurance Services',
    category: 'Financial Services',
    businessCategory: 'Insurance Agent',
    description: 'Insurance products and coverage options',
    theme: 'modern',
    thumbnail: 'https://images.unsplash.com/photo-1450101499163-c8848c66ca85?w=400&q=80',
    slides: [
      {
        title: 'PROTECT WHAT MATTERS',
        content: '[Agent Name] | [Company]',
        layout: 'title_content',
        backgroundImage: 'https://images.unsplash.com/photo-1450101499163-c8848c66ca85?w=1920&q=80',
        backgroundColor: '#16a34a'
      },
      {
        title: 'Coverage Options',
        content: '🏠 Home Insurance\n🚗 Auto Insurance\n💼 Business Insurance\n❤️ Life Insurance\n🏥 Health Insurance',
        layout: 'title_content',
        backgroundImage: '',
        backgroundColor: '#f0fdf4'
      },
      {
        title: 'Why Work With Me',
        content: '• Personalized Service\n• Multiple Carrier Options\n• Competitive Rates\n• Claims Assistance\n• Regular Policy Reviews',
        layout: 'title_content',
        backgroundImage: '',
        backgroundColor: '#ffffff'
      },
      {
        title: 'Free Quote Today',
        content: '📞 [Phone]\n📧 [Email]\n📍 Office: [Address]\n🌐 [Website]\n\nProtecting Your Future',
        layout: 'title_content',
        backgroundImage: '',
        backgroundColor: '#16a34a'
      }
    ]
  },
  {
    id: 'marketing-agency',
    name: 'Marketing Agency',
    category: 'Marketing',
    businessCategory: 'Marketing Specialist',
    description: 'Digital marketing services presentation',
    theme: 'modern',
    thumbnail: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=400&q=80',
    slides: [
      {
        title: 'GROW YOUR BUSINESS',
        content: 'Digital Marketing Solutions',
        layout: 'title_content',
        backgroundImage: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=1920&q=80',
        backgroundColor: '#8b5cf6'
      },
      {
        title: 'Our Services',
        content: '📱 Social Media Marketing\n🎯 PPC Advertising\n📊 SEO & Content Strategy\n📧 Email Marketing\n🎨 Brand Development',
        layout: 'title_content',
        backgroundImage: '',
        backgroundColor: '#f5f3ff'
      },
      {
        title: 'Proven Results',
        content: '• 300% Average ROI\n• 50+ Happy Clients\n• 5M+ Impressions Generated\n• Award-Winning Campaigns\n• Transparent Reporting',
        layout: 'title_content',
        backgroundImage: '',
        backgroundColor: '#ffffff'
      },
      {
        title: 'Let\'s Talk Strategy',
        content: '📞 [Phone]\n📧 [Email]\n🌐 [Website]\n📍 [Location]\n\nFree Marketing Audit',
        layout: 'title_content',
        backgroundImage: '',
        backgroundColor: '#8b5cf6'
      }
    ]
  }
];

// Merge business templates with general templates
export const getAllTemplates = (generalTemplates) => {
  return [...generalTemplates, ...businessSlideTemplates];
};
